import { useEffect } from 'react';

import { useValidateSession } from '@breezeventures/web-ph-client-auth/api';
import {
  isAuthorisedAtom,
  isSessionValidatedAtom,
  logoutAtom,
} from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue, useSetAtom } from 'jotai';

import { useAuthApi } from '../api';

export const useSessionInit = () => {
  const authApi = useAuthApi();
  const isSessionValidated = useAtomValue(isSessionValidatedAtom);
  const setIsAuthorised = useSetAtom(isAuthorisedAtom);
  const setIsSessionValidated = useSetAtom(isSessionValidatedAtom);
  const logout = useSetAtom(logoutAtom);

  const validateQuery = useValidateSession({ authApi });

  useEffect(() => {
    if (validateQuery.isSuccess && !isSessionValidated) {
      setIsAuthorised(true);
      setIsSessionValidated(true);
    }
  }, [validateQuery.isSuccess, isSessionValidated]);

  useEffect(() => {
    if (validateQuery.isError) {
      logout();
      setIsSessionValidated(true);
    }
  }, [validateQuery.isError]);
};
